import type { FaireProductEntity } from "../../entity_types/product";

export const p_nh86w6uhqq: FaireProductEntity = {
  token: "p_nh86w6uhqq",
  type: "product",
  name: "Natural Vitality - Calm Sleep Gmmy Blbry Pom - 1 Each-120 Ct",
  brandToken: "b_7xgwjjb7p6",
  brandName: "Everyday Supply Co",
  imageUrl:
    "https://cdn.faire.com/fastly/bac505da9ce9b022ddc0f062e540a9ff2ceb031766810e16344c3899166d7aaf.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/3062d168b48dd93b211032c71cc7d7f202cff936e1cb648c10c47efcfcf385ef.jpeg",
  ],
  priceDollars: 27.09,
  description: "Natural Vitality - Calm Sleep Gmmy Blbry Pom - 1 Each-120 CT",
  tags: [],
  msrpDollars: 39.28,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:52:28.681Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
